import apiService from './apiService';
import { RUNTIME_CONFIG_API } from '../../Constants';

const runtimeConfigApi = {
  fetchMetadata: () => apiService.get(RUNTIME_CONFIG_API),

  fetchDocument: (configId) => apiService.get(`${RUNTIME_CONFIG_API}/${configId}`),

  applyChange: ({
    configId,
    operation,
    author,
    entry,
    expectedVersion,
    confirmOverlap,
  }) => {
    const payload = {
      configId,
      operation,
      author,
      entry,
    };
    if (expectedVersion != null) {
      payload.expectedVersion = expectedVersion;
    }
    if (confirmOverlap === true) {
      payload.confirmOverlap = true;
    }
    return apiService.post(RUNTIME_CONFIG_API, payload);
  },
};

export default runtimeConfigApi;
